import * as React from "react";
import { useState, useRef } from "react";
import { IconButton, ModalSubmit } from "components/common";
import { ButtonToolbar, Modal, Menu, MenuItem } from "components/bootstrap";
import usePluginEntities from "hooks/usePluginEntities";
import Routes from "routing/Routes";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import EventDetails from "./EventDetails";
const usePluggableDashboardActions = (eventId) => {
  const modalRefs = useRef({});
  const pluggableActions = usePluginEntities("views.components.widgets.events.actions");
  const availableActions = pluggableActions.filter(
    (perspective) => perspective.useCondition ? !!perspective.useCondition() : true
  );
  const actions = availableActions.map(({ component: PluggableDashboardAction, key }) => /* @__PURE__ */ React.createElement(PluggableDashboardAction, { key: `event-action-${key}`, eventId, modalRef: () => modalRefs.current[key] }));
  const actionModals = availableActions.filter(({ modal }) => !!modal).map(({ modal: ActionModal, key }) => /* @__PURE__ */ React.createElement(
    ActionModal,
    {
      key: `event-action-modal-${key}`,
      eventId,
      ref: (r) => {
        modalRefs.current[key] = r;
      }
    }
  ));
  return { actions, actionModals };
};
const RowActions = ({ eventId, hasReplayInfo, eventDefinitionId }) => {
  const user = useCurrentUser();
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const toggleDetailsModal = () => setShowDetailsModal((cur) => !cur);
  const { actions: pluggableActions, actionModals: pluggableActionModals } = usePluggableDashboardActions(eventId);
  const moreActions = [
    hasReplayInfo && isPermitted(user.permissions, `eventdefinitions:read:${eventDefinitionId}`) ? /* @__PURE__ */ React.createElement(MenuItem, { href: Routes.ALERTS.replay_search(eventId), target: "_blank", key: "replay-search" }, "Replay search") : null,
    pluggableActions.length ? pluggableActions : null
  ].filter(Boolean);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(IconButton, { name: "open_in_full", title: "View event details", onClick: toggleDetailsModal }), !!moreActions.length && /* @__PURE__ */ React.createElement(Menu, { position: "bottom-end" }, /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(IconButton, { name: "more_vert", title: "Toggle event actions" })), /* @__PURE__ */ React.createElement(Menu.Dropdown, null, moreActions))), showDetailsModal && /* @__PURE__ */ React.createElement(Modal, { show: showDetailsModal, bsSize: "large", onHide: toggleDetailsModal }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Event details")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(EventDetails, { eventId })), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      displayCancel: false,
      onSubmit: toggleDetailsModal,
      submitButtonType: "button",
      submitButtonText: "Close"
    }
  ))), pluggableActionModals);
};
export default RowActions;
